import axios from 'axios';
import Cookies from 'js-cookie';

const appToken = process.env.TOKEN;

const options = {
    baseURL: process.env.API_URL,
    timeout: 50000,
    headers: {
        'Content-Type': 'application/json',
        'X-JTA-token': appToken
    }
};

const api = axios.create(options);

api.interceptors.request.use((config) => {
    let token = Cookies.get('user_token');
    if (token) {
        config.headers['X-JTC-token'] = token;
    }
    return config;
}, (err) => {
    if (err.response && err.response.status === 401) {
        Cookies.remove('user_token', {domain: process.env.COOKIE_DOMAIN});
        location = '/';
    }
    return Promise.reject(err);
});

export {
    api
}
